import { createMatchSelector } from 'connected-react-router';
import { connect } from 'react-redux';
import { path, pipe, applySpec } from 'ramda';

import TransmissionReportContent from 'components/TransmissionReport/Content';

import {
  getReportItemShouldShowLoading,
  getReportItemPacingValue,
  getReportItemShockValue,
  getReportItemBatteryLife,
  getReportItemLastUpdated,
  getFormatedReportItemShocks,
  getReportItemAlert,
  getReportItemStatus,
} from 'store/selectors/reports/singleItems';
import { getUserRole } from 'store/selectors/user';

const mapStateToProps = (state, { reportId }) =>
  applySpec({
    alertValue: getReportItemAlert(reportId),
    batteryLife: getReportItemBatteryLife(reportId),
    lastUpdated: getReportItemLastUpdated(reportId),
    loading: getReportItemShouldShowLoading(reportId),
    pacingValue: getReportItemPacingValue(reportId),
    role: getUserRole,
    shockValue: getReportItemShockValue(reportId),
    shocks: getFormatedReportItemShocks(reportId),
    status: getReportItemStatus(reportId),
    patientId: pipe(
      createMatchSelector('/patient/:id'),
      path(['params', 'id']),
    ),
  })(state);

export default connect(mapStateToProps)(TransmissionReportContent);
